import { render, staticRenderFns } from "./TransProgramOverviewContent.vue?vue&type=template&id=4970c530"
import script from "./TransProgramOverviewContent.vue?vue&type=script&lang=ts"
export * from "./TransProgramOverviewContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports